import React, { useState, useEffect } from 'react';
import './scrollToTopButton.css'
import { Button, Tooltip } from 'antd';
import { ArrowUpOutlined } from '@ant-design/icons';
const ScrollToTopButton: React.FC = () => {

    const scrollToTop = () => {
        document.getElementById('content-main')?.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    return (
        <Tooltip title='Scroll to top'>
             <Button type ='primary' className="scroll-to-top-button" onClick={scrollToTop} shape='circle' icon={<ArrowUpOutlined/>}/>
        </Tooltip>
    );
};

export default ScrollToTopButton;
